import { forceUpdateInputValueWithoutOpeningDropdown } from '../elements/input.js';
import { updateMapPinPosition } from '../elements/map.js';

export function parseCentroideLL( centroideString ) {
	if ( typeof centroideString !== 'string' ) return null;
	const match = centroideString.match( /POINT\(([-\d.]+) ([-\d.]+)\)/ );
	if ( ! match ) return null;
	return { long: match[ 1 ], lat: match[ 2 ] };
}

export function getDocsFromResponse( data ) {
	return data && data.response && Array.isArray( data.response.docs )
		? data.response.docs
		: [];
}

export async function reverseGeocode( apiRequest, apiReverseUrl, coords ) {
	const url = new URL( apiReverseUrl );
	url.searchParams.set( 'lat', coords.latitude );
	url.searchParams.set( 'lon', coords.longitude );
	url.searchParams.set( 'rows', 1 );
	const data = await apiRequest( url.toString() );
	return data?.response?.docs?.[ 0 ] ?? null;
}

export async function lookupById( apiRequest, apiLookupUrl, apiLookupIdParam, id ) {
	const url = new URL( apiLookupUrl );
	const paramKey = apiLookupIdParam.endsWith( '=' )
		? apiLookupIdParam.slice( 0, -1 )
		: apiLookupIdParam;
	url.searchParams.set( paramKey, id );
	const data = await apiRequest( url.toString() );
	return data?.response?.docs?.[ 0 ] ?? null;
}

export function fillAddressFromDoc( field, doc ) {
	forceUpdateInputValueWithoutOpeningDropdown( field, doc );

	const coords = parseCentroideLL( doc.centroide_ll );
	if ( coords ) {
		const mapContainer = field.closest( '.acf-map-container' );
		const mapElement = mapContainer?.querySelector( '.acf-map-element' );
		if ( mapElement ) {
			updateMapPinPosition( mapElement, coords.long, coords.lat );
		}
	}
}
